// Copyright (c) 2026 Broadcom. All rights reserved.
// Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc. and/or its subsidiaries.
// Generated by: maverick-file-header, license, codestyle, codequality, clean-code, ai-specific, technology-stack, maverick-file-creation-log
//
// Route guard for the SSO debug page.
// Requires both an authenticated session AND the CDA_DevTeam group (devteam role).
//
// Unlike ProtectedRoute, an authenticated-but-not-devteam user sees a plain 403
// message rather than a redirect to /login. This avoids leaking the page's
// existence through redirect behaviour visible to regular users.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedDevRoute = ({ children }) => {
  const { isAuthenticated, isDevTeam, authLoading } = useAuth();
  const location = useLocation();

  if (authLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isDevTeam) {
    return (
      <div style={{
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        minHeight:      '100vh',
        background:     '#F5F6F8',
        flexDirection:  'column',
        gap:            '0.5rem',
      }}>
        <p style={{ color: '#CC0000', fontWeight: 600, fontSize: '1rem' }}>403 — Access Denied</p>
        <p style={{ color: '#53565A', fontSize: '0.875rem' }}>
          This page requires membership in the CDA_DevTeam group.
        </p>
      </div>
    );
  }

  return children;
};


